import {
	AnalyticsAdmin,
	AnalyticsFree,
	AnalyticsInstructor,
	AnalyticsScratchCards,
	AnalyticsWallet,
} from '@Components/UI/Analytics/Assets/Icons/Icons';
import { blue, deepPurple, green, orange, red, yellow } from '@mui/material/colors';
import React from 'react';

/**
 * The hub's six method buckets. `promocode` is derived server-side out of
 * wallet purchases that used a code — stored purchase_method stays 'wallet',
 * so the five legacy buckets everywhere else are unaffected.
 */
export const HUB_METHODS = [
	'wallet',
	'promocode',
	'scratchcard',
	'free',
	'admin',
	'instructor',
] as const;
export type HubMethod = (typeof HUB_METHODS)[number];

export const HUB_METHOD_LABELS: Record<HubMethod, string> = {
	wallet: 'Wallet',
	promocode: 'Promocode',
	scratchcard: 'Scratchcard',
	free: 'Free',
	admin: 'Admin',
	instructor: 'Instructor',
};

/** pickTypeColor's palette + blue for the new promocode bucket */
export const pickMethodColor = (method: string) => {
	if (method === 'admin') return red[500];
	if (method === 'wallet') return deepPurple[500];
	if (method === 'promocode') return blue[500];
	if (method === 'scratchcard') return orange[500];
	if (method === 'free') return yellow[600];
	return green.A700;
};

/** enrollmentIcons + a promocode entry (wallet glyph, recolored by the card) */
export const hubMethodIcons: Record<HubMethod, JSX.Element> = {
	wallet: <AnalyticsWallet />,
	promocode: <AnalyticsWallet />,
	scratchcard: <AnalyticsScratchCards />,
	free: <AnalyticsFree />,
	admin: <AnalyticsAdmin />,
	instructor: <AnalyticsInstructor />,
};

export const FAMILY_LABELS: Record<string, string> = {
	'classrooms': 'Classrooms',
	'standalone-courses': 'Standalone Courses',
	'bundles': 'Bundles',
};

export const FAMILY_COLORS: Record<string, string> = {
	'classrooms': '#6C63FF',
	'standalone-courses': '#5AC0FC',
	'bundles': '#FF8532',
};

/**
 * The hub's default reporting window starts at the most recent 1st of
 * August — the academic season boundary.
 */
export const analyticsSeasonStart = () => {
	const now = new Date();
	const year = now.getMonth() >= 7 ? now.getFullYear() : now.getFullYear() - 1;
	return new Date(year, 7, 1);
};
